import React from 'react';
export function ResultsCollage() {
  const images = [{
    src: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=400&h=400&fit=crop&crop=faces',
    alt: 'Beautiful dog portrait with warm lighting'
  }, {
    src: 'https://images.unsplash.com/photo-1530126483408-aa533e55bdb2?w=400&h=400&fit=crop&crop=faces',
    alt: 'Energetic dog action shot running outdoors'
  }, {
    src: 'https://images.unsplash.com/photo-1518717758536-85ae29035b6d?w=400&h=400&fit=crop&crop=faces',
    alt: 'Expressive dog showing personality in candid moment'
  }, {
    src: 'https://images.unsplash.com/photo-1583511655857-d19b40a7a54e?w=400&h=400&fit=crop&crop=faces',
    alt: 'Cozy indoor dog photo with warm tones'
  }, {
    src: 'https://images.unsplash.com/photo-1477884213360-7e9d7dcc8f9b?w=400&h=400&fit=crop&crop=faces',
    alt: 'Beautiful outdoor dog photo in natural setting'
  }, {
    src: 'https://images.unsplash.com/photo-1544568100-847a948585b9?w=400&h=400&fit=crop&crop=faces',
    alt: 'Adorable puppy photo with soft lighting'
  }];
  return <section className="bg-warm-deep py-16 md:py-20 px-4" data-id="element-232">
      <div className="max-w-4xl mx-auto" data-id="element-233">
        {/* Heading */}
        <p className="font-sans font-medium text-soft-gold uppercase tracking-wider text-xs md:text-sm text-center mb-8" data-id="element-234">
          Beautiful results from different kinds of dogs, moments, and styles
        </p>

        {/* Collage grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4 mb-8 max-w-3xl mx-auto" data-id="element-235">
          {images.map((img, index) => <div key={index} className="rounded-xl overflow-hidden shadow-md aspect-square" data-id="element-236">
              <img src={img.src} alt={img.alt} className="w-full h-full object-cover" data-id="element-237" />
            </div>)}
        </div>

        {/* Text below */}
        <p className="font-sans text-lg md:text-xl text-gray-800 text-center max-w-2xl mx-auto leading-relaxed" data-id="element-238">
          From portraits to action shots to cozy everyday moments, this system
          helps you create{' '}
          <span className="font-semibold text-warm-hero" data-id="element-239">
            more photos you'll genuinely love.
          </span>
        </p>
      </div>
    </section>;
}